import { Modal, Button, Icon, Typography } from '@scale/scaleui';

type CodenamesWarningModalProps = {
  open: boolean;
  onClose: () => void;
  codename: string;
  field?: string;
};

export function CodenamesWarningModal({
  open,
  codename,
  field,
  onClose,
}: CodenamesWarningModalProps) {
  return (
    <Modal
      className="scaleui scale-theme scale-tailwind [&_form]:overflow-visible "
      title="Codenames Error"
      actions={
        <div className="flex items-center gap-2 justify-end">
          <Button type="button" variant="danger" onClick={onClose}>
            {'Cancel'}
          </Button>
        </div>
      }
      open={open}
      innerClassName=""
      onClose={onClose}
    >
      <div className="flex items-center ">
        <Icon icon="message-exclamation" variant="danger" size="lg" />
        <Typography.Paragraph2>
          We detected the codename {codename}
          {field ? ` in the field "${field}"` : ''}. Please avoid using codenames in names that are
          CB facing.
        </Typography.Paragraph2>
      </div>
    </Modal>
  );
}
